import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { LangContext } from "../../providers/LangContext";
import { ReviewService } from "../../services/reviewService";
import { LoaderSpinner } from "../commons/loaderSpinner/loaderSpinner";
import './reviews.scss';
import MediaGallery from "../commons/mediaGallery/mediaGallery";
import type { EventReview } from "../../interfaces/eventReview";

export function Reviews(){

    const lang = useContext(LangContext);
    const langValue = lang.lang;
    const { t } = useTranslation();
    const reviewService = ReviewService();
    const [events,setEvents] = useState<EventReview[]>([]);
    const [loading, setLoading] = useState(true);
    useEffect(()=>{
        const fetchReviews = async () => {
            try {
                 setLoading(true)
                const res: any = await reviewService.getAll();
                setEvents(res.data as Array<EventReview>);
            } catch (error) {
                console.error("Erreur récupération catégories", error);
            }finally{
                 setLoading(false);
            }
        };
        fetchReviews();
    },[langValue]);

    return (
        <div className='reviews-container content-container'>
            {loading ? (
            <LoaderSpinner visible={true} />
            ) : (
            <div >
                <h1>{t("reviews.label")}</h1>
                {events.map(eventReview=>
                    <div key={eventReview.id} className="align-left">
                        <h3>{eventReview.title}</h3>
                        <MediaGallery key={eventReview.id.toString() + langValue} list={eventReview.gallery} />
                    </div>
                )
                }
            </div>)}
        </div>
    )
}
